import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import SupportPage from './SupportPage';
import { messaging, sendSupportMessage, getMessage, onFilesChange, onFilesError, statusType } from 'src/actions/supportPageAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { downloadMessageAttachment } from 'src/actions/filedownloadAction';
import { push } from 'react-router-redux';
// import { saveQueryType, saveMessages, saveAttachment, doSubmit } from 'src/actions/supportAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
  return {
    // errorMessage: state.errorState.errorMessage,
    // errorBar: state.errorState.errorBar,
    // successMessage: state.errorState.successMessage,
    // successBar: state.errorState.successBar,
    customer: state.user.userDetails.userName,
    getSupportMessage: state.supportPage.getSupportMessage,
    messages: state.supportPage.message,
    ticketno: state.supportRequest.ticketno,
    status: state.supportRequest.status,
    date: state.supportRequest.date,
    supporttype: state.supportRequest.supporttype,
    mtype: state.supportRequest.mtype,
    messageFiles: state.supportPage.messageFiles
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      // // dispatch(saveMessages(''));
      // dispatch(getMessage);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      dispatch(getMessage);
    },
    onSubmit: () => {
      dispatch(sendSupportMessage);
    },
    messaging: (messages: string) => {
      dispatch(messaging(messages));
    },
    onFilesChange: function (messageFiles: Array<File>) {
      dispatch(onFilesChange(messageFiles));
    },
    onFilesError: function (error: Error, images: Array<File>) {
      dispatch(onFilesError(error, images));
    },
    msgAtt: (msgAttachment: string, ociStatus: string) => {
      dispatch(downloadMessageAttachment(msgAttachment, ociStatus));
    },
    saveStatusType: (statustype: string) => {
      dispatch(statusType(statustype));
    },
    goToFeedback: () => {
      dispatch(push('/app/support-feedback'));
    },
    // handleClose: () => {
    //   dispatch(handleCloseAlert);
    // },
  };
};

const SupportPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportPage);

export default SupportPageContainer;



// WEBPACK FOOTER //
// ./src/components/supportPage/SupportPageContainer.tsx